import { render, staticRenderFns } from "./DesktopSide.vue?vue&type=template&id=ddc52f30&scoped=true&"
import script from "./DesktopSide.vue?vue&type=script&lang=ts&"
export * from "./DesktopSide.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopSide.vue?vue&type=style&index=0&id=ddc52f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc52f30",
  null
  
)

export default component.exports